import React, { useState, useEffect } from 'react';
import './LimitReachedModal.css';

function LimitReachedModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [limitData, setLimitData] = useState(null);

  useEffect(() => {
    const handleShowModal = (event) => {
      setLimitData(event.detail);
      setIsOpen(true);
    };

    window.addEventListener('show-limit-modal', handleShowModal);
    return () => {
      window.removeEventListener('show-limit-modal', handleShowModal);
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleUpgrade = () => {
    setIsOpen(false);
    window.dispatchEvent(new CustomEvent('open-settings-modal'));
  };

  if (!isOpen || !limitData) return null;

  return (
    <div className="limit-modal-overlay" onClick={handleClose}>
      <div
        className="limit-modal-content"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="limit-modal-title"
      >
        <div className="limit-modal-header">
          <h2 id="limit-modal-title">Usage Limit Reached</h2>
          <button
            className="limit-modal-close"
            onClick={handleClose}
            aria-label="Close"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div className="limit-modal-body">
          <p className="limit-message">{limitData.message}</p>

          {limitData.currentUsage !== undefined && limitData.limit !== undefined && (
            <div className="limit-usage-display">
              <span className="limit-usage-current">{limitData.currentUsage}</span>
              <span className="limit-usage-separator">/</span>
              <span className="limit-usage-limit">{limitData.limit}</span>
            </div>
          )}

          <div className="limit-benefits">
            <h3>Upgrade to Premium for:</h3>
            <ul>
              <li>
                <svg className="check-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Unlimited deck uploads
              </li>
              <li>
                <svg className="check-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Unlimited quiz questions
              </li>
              <li>
                <svg className="check-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
                Priority support
              </li>
            </ul>
          </div>
        </div>

        <div className="limit-modal-footer">
          <button
            className="limit-modal-btn limit-modal-btn-secondary"
            onClick={handleClose}
          >
            Maybe Later
          </button>
          <button
            className="limit-modal-btn limit-modal-btn-primary"
            onClick={handleUpgrade}
          >
            Upgrade to Premium
          </button>
        </div>
      </div>
    </div>
  );
}

export default LimitReachedModal;
